import React from "react";
import { Link } from "react-router-dom";
import { Menu } from "lucide-react";

import mobileLogo from "../../assets/images/mobile-logo.svg";
import UserProfile from "./UserProfile";
import PageTitle from "./PageTitle";

const CustomHeader = ({
  setOpenSidebar,
  headerConfig,
  headerTabs,
  numberOfData,
}) => {
  const isDesktop = window.innerWidth > 999;
  return (
    <div className="header-row">
      <Menu
        strokeWidth={2}
        size={30}
        className="md:hidden"
        onClick={() => setOpenSidebar(true)}
        color="white"
      />
      <Link to="/home" className="md:hidden flex">
        <img src={mobileLogo} alt="menuLogo" className="w-60" />
      </Link>
      {headerConfig && (
        <PageTitle pageTitle={headerConfig.title} numberOfData={numberOfData} />
      )}
      {headerTabs && isDesktop && headerTabs}
      <div className="flex items-center">
        <UserProfile />
      </div>
    </div>
  );
};
export default CustomHeader;
